<template lang="pug">
.tab-list
  .tab--active(v-for="(filter, i) in selectedFilters", :key="filter.name", :style="{ background: colors[i] }") 
    div {{ filterText(filter) }}
    .tab__close
      inline-svg(:src="require('@/assets/icons/dynamic-issues/index/close.svg')", @click="removeFilter(filter)")
  .tab--reset(@click="resetAllFilters") {{ currentLocales.clear_all }}
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "@/store";
import { dynamicIssuesLocales } from "@/services/useLocales";
import { currentLocale } from "@/services/useLocales";
import chroma from "chroma-js";
import i18n from "@/plugins/vue-i18n";

const props = defineProps({
  /** Текущий грид */
  grid: { type: String, default: "" },
  /** Список фильтров. Пример: { "service_id": [ { "title": "Манжерок", "id": 7 }, ... ], ... } */
  filtersData: { type: Array, default: () => [] },
});

const store = useStore();

const emit = defineEmits([
  /** Эмит на обновление страницы после изменения фильтров. Не нуждается в параметрах */
  "reset",
]);

const i18nLocales = computed(() => i18n["messages"][currentLocale.value]);
const colors = computed(() => {
  const length = selectedFilters.value.length;
  const startColor = "#D8DFFF";
  const middleColor = "#D6EEE3";
  const endColor = "#FFD6D3";

  if (length == 1) {
    return [startColor];
  } else if (length == 2) {
    return [startColor, endColor];
  } else if (length == 3) {
    return [startColor, middleColor, endColor];
  } else {
    return chroma.scale([startColor, middleColor, endColor]).mode("lch").colors(length);
  }
});
const currentLocales = computed(() => dynamicIssuesLocales.value.filters);
const selectedFilters = computed(() => props.filtersData);

const filterText = filter => {
  return `${filter.label} (${filter.value.length}${i18nLocales.value.items})`;
};

const removeFilter = filter => {
  if (filter.name) {
    store.commit("resetFilter", { grid_name: props.grid, filter: filter.name });
  }

  emit("reset");
};

const resetAllFilters = () => {
  selectedFilters.value.map(item => {
    store.commit("resetFilter", { grid_name: props.grid, filter: item.name });
  });

  emit("reset");
};
</script>

<style scoped lang="scss">
.tab-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: flex-start;
  margin-bottom: 15px;

  .tab {
    &__close {
      cursor: pointer;
      display: flex;
    }

    &--active {
      color: var(--dynamic-issues-selection-tabs-color);
      border-radius: 17px;
      padding: 4px 12px;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &--reset {
      color: var(--dynamic-issues-selection-tabs-color);
      background-color: var(--dynamic-issues-selection-tabs-background);
      border: 0.5px solid var(--dynamic-issues-selection-tabs-border-color);
      border-radius: 17px;
      padding: 4px 12px;
      text-transform: uppercase;
      cursor: pointer;
    }
  }
}
</style>
